<template>
  <section id="volunteer" aria-labelledby="volunteer-title" class="py-10 sm:py-14">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="volunteer-hero-bg overflow-hidden rounded-3xl px-6 py-8 text-white shadow-2xl sm:px-10 sm:py-10">
        <p class="inline-flex rounded-full bg-white bg-opacity-20 px-4 py-1 text-xs font-semibold uppercase tracking-widest text-blue-light">Serve with us</p>
        <h1 id="volunteer-title" class="mt-4 font-display text-4xl font-bold tracking-tight sm:text-5xl">
          Volunteer with Prayer Storm
        </h1>
        <p class="mt-4 max-w-3xl text-lg text-white sm:text-xl">
          Bring your gifts, strengthen the mission, and help create spaces for people to encounter Jesus.
          Start your application today!
        </p>

        <p class="mt-5 text-sm font-semibold uppercase tracking-widest text-blue-light">Example areas to serve in</p>
        <ul class="mt-3 flex flex-wrap gap-2 text-sm">
          <li v-for="area in featuredAreas" :key="area" class="rounded-full bg-white bg-opacity-20 px-3 py-1 font-semibold">
            {{ area }}
          </li>
        </ul>

        <button type="button" @click="scrollToVolunteerFlow" class="mt-7 inline-flex items-center rounded-xl bg-white px-5 py-3 text-sm font-semibold text-gray-900 transition hover:-translate-y-1 hover:bg-transparent hover:text-white border-2 hover:border-2 hover:border-white">
          Start your application
        </button>
      </div>

      <div id="volunteer-flow" class="mt-10">
        <h2 class="text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">I would like to apply to volunteer for...</h2>

        <div class="mt-5 grid gap-4 sm:grid-cols-2">
          <button
            v-for="option in regionOptions"
            :key="option.key"
            type="button"
            @click="goToRegionForm(option.key)"
            class="relative rounded-2xl px-6 py-7 pr-16 text-left text-white shadow-lg transition hover:-translate-y-1"
            :class="[
              option.key === 'ukBattleForBritain' ? 'volunteer-choice-card-b4b' : 'volunteer-choice-card',
              'opacity-95 hover:opacity-100'
            ]"
          >
            <span class="absolute right-4 top-4 inline-flex h-8 w-8 items-center justify-center rounded-full bg-white bg-opacity-80 text-xl font-bold text-gray-900">
              ->
            </span>
            <p class="text-2xl font-bold">{{ option.label }}</p>
            <p class="mt-2 text-sm text-white">{{ option.hint }}</p>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

const formUrls = {
  uk: 'https://prayerstorm.churchsuite.com/-/forms/a5hcty0s',
  ukBattleForBritain: 'https://prayerstorm.churchsuite.com/-/forms/fkpxtmsp',
  usa: 'https://prayerstorm.churchsuite.com/-/forms/jirkmcns',
  netherlands: 'https://prayerstorm.churchsuite.com/-/forms/b2yt5j0m'
}

const regionOptions = [
  {
    key: 'uk',
    label: 'UK',
    hint: 'For events and ongoing ministry in the UK'
  },
  // {
  //   key: 'ukBattleForBritain',
  //   label: 'Battle for Britain 2026',
  //   hint: 'Our Annual Conference, 20-22 Aug, Manchester, UK'
  // },
  {
    key: 'usa',
    label: 'USA',
    hint: 'For events and ongoing ministry in the USA'
  },
  {
    key: 'netherlands',
    label: 'Netherlands',
    hint: 'For events and ongoing ministry in the Netherlands'
  }
]

const featuredAreas = [
  'Prayer Storm Kids',
  'Ministry Team',
  'Production - Audio',
  'Production - Video',
  'Registration',
  'Stewards',
  'Guest Services Protocol',
  'Hospitality',
  'Event Co-ordination Support',
  'Finance',
  'Administration',
  'Social Media',
  'Merchandise',
  'Health and Safety',
  'First Aid',
  'Medical Team'
]

const getFormUrlByRegion = (regionKey) => {
  if (regionKey === 'uk') {
    return formUrls.uk
  }

  if (regionKey === 'ukBattleForBritain') {
    return formUrls.ukBattleForBritain
  }

  if (regionKey === 'usa') {
    return formUrls.usa
  }

  if (regionKey === 'netherlands') {
    return formUrls.netherlands
  }

  return ''
}

const goToRegionForm = (regionKey) => {
  const formUrl = getFormUrlByRegion(regionKey)

  if (!formUrl) {
    return
  }

  window.open(formUrl, '_blank', 'noopener')
}

const scrollToVolunteerFlow = () => {
  const volunteerFlowEl = document.getElementById('volunteer-flow')

  if (!volunteerFlowEl) {
    return
  }

  volunteerFlowEl.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  })
}
</script>

<style scoped>
.volunteer-hero-bg {
  background: linear-gradient(120deg, #111827 0%, #02273a 45%, #2a83a1 100%);
}

.volunteer-choice-card {
  background: linear-gradient(120deg, #02273a 0%, #2a83a1 100%);
}

.volunteer-choice-card-b4b {
  background: linear-gradient(120deg, #0a0a0a 0%, #1a0707 45%, #5b1111 100%);
}

</style>
